import { render } from "./Plant.vue?vue&type=template&id=ab0f1a16"
import script from "./Plant.vue?vue&type=script&lang=js"
export * from "./Plant.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__